document.addEventListener("DOMContentLoaded", function () {
  const onePageBtn = document.getElementById("one-page-view");
  const twoPageBtn = document.getElementById("two-page-view");

  const gridContainers = [
    document.querySelector(".book-layout"),
    document.querySelector(".intro-grid"),
    document.querySelector(".story-grid"),
  ];

  function setGridLayout({ columns, isOnePage }) {
    gridContainers.forEach((container) => {
      if (container) {
        container.style.gridTemplateColumns = `repeat(${columns}, 1fr)`;
        container.style.maxWidth = isOnePage ? "580px" : "100%";
        container.style.margin = isOnePage ? "0 auto" : "unset";
      }
    });
  }

  function setActive(button) {
    [onePageBtn, twoPageBtn].forEach((btn) => btn.classList.remove("active"));
    button.classList.add("active");
  }

  onePageBtn.addEventListener("click", () => {
    setGridLayout({ columns: 1, isOnePage: true });
    setActive(onePageBtn);
  });

  twoPageBtn.addEventListener("click", () => {
    setGridLayout({ columns: 2, isOnePage: false });
    setActive(twoPageBtn);
  });
});
